import {LocalApplicationModel} from '../../models/api/localApplicationModel';
import {
  ApiOauthClient,
  serializeOauthClient,
  UnsavedOauthClientModel,
} from '../../models/api/oauthClientModel';
import {putApiAsync} from '../../services/http/http';

/*
 * Mutations.
 */

export async function saveOauthClientAsync(
  application: LocalApplicationModel,
  oauthClient: UnsavedOauthClientModel,
) {
  await putApiAsync(ApiOauthClient, `${application.url}/oauth_client`, serializeOauthClient(oauthClient));
}
